import styled from '@emotion/styled'
import { Form as AntdForm, Radio as AntdRadio, Checkbox as AntdCheckbox } from 'antd'

export const Container = styled('div')`
  padding: 32px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: white;
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 32px;
`

export const Form = styled(AntdForm)``

export const RadioGroup = styled(AntdRadio.Group)``

export const Radio = styled(AntdRadio)``
